import React, {Component} from 'react';
import {Result, Button, Row, Col, Alert, Divider} from 'antd';
import Header from "./inc/Header";
import {Redirect, Link} from "react-router-dom";
import {FooterApps} from "./inc/FooterApps";
import {t} from '../../constant/i18n';
import {THEME} from '../../constant/theme';

class InscrTermine extends Component {

    constructor(props) {
        super(props);
        this.state = {
            paramHeader: {},
            idOrder: localStorage.getItem('order_log_id'),
            orderIdCat: localStorage.getItem('order_idcat'),
        }
    }

    render() {
        var ref = localStorage.getItem('order_log_ref')

        if (this.state.orderIdCat == 3) {
            var message = <Row>
                <Col span={12} offset={6} style={{textAlign: 'left'}}>
                    <br/>
                    {t('inscrTermine.hello', {name: localStorage.getItem('membre_prenom')})}
                    <br/><br/>
                    {t('inscrTermine.langueOpening')}
                    <br/><br/>
                    {t('inscrTermine.validateBelow')}
                    <br/><br/>
                    {t('inscrTermine.responseDelay')}

                    <br/>
                    <br/>
                    <b>{t('formRegister.globalongTeam')}</b><br/>
                    <a href={THEME.urls.site}>{THEME.urls.site}</a><br/>
                    <a href={'mailto:' + THEME.email}>{THEME.email}</a>

                </Col>
            </Row>

        } else {
            var message = <Row>
                <Col span={12} offset={6} style={{textAlign: 'left'}}>
                    <br/>
                    {t('inscrTermine.hello', {name: localStorage.getItem('membre_prenom')})}
                    <br/>
                    <br/>
                    {t('inscrTermine.langueOpening')}
                    <br/>
                    <br/>
                    {t('inscrTermine.mustComplete')}
                    <br/>
                    {t('inscrTermine.applicationContent')}
                    <br/><br/>
                    {t('inscrTermine.yourCV')}
                    <br/><br/>
                    {t('inscrTermine.presentationLetterIntro')}<br/>
                    • {t('inscrTermine.whyLeave')}<br/>
                    • {t('inscrTermine.whyCountry')}<br/>
                    • {t('inscrTermine.qualifications')}<br/>
                    • {t('inscrTermine.expectations')}
                    <br/><br/>
                    {t('inscrTermine.criminalRecord')}
                    <br/><br/>
                    <Alert
                        message={t('inscrTermine.documentsLanguageTitle')}
                        description={<div>
                            <ul>
                                <li>{t('inscrTermine.documentsLanguageFr')}</li>
                                <li>{t('inscrTermine.documentsLanguageEs')}</li>
                                <li>{t('inscrTermine.documentsLanguageEn')}</li>
                            </ul>
                        </div>}
                        type="warning"
                        showIcon
                        closable
                    />

                    <br/>
                    <br/>
                    <b>{t('formRegister.globalongTeam')}</b><br/>
                    <a href={THEME.urls.site}>{THEME.urls.site}</a><br/>
                    <a href={'mailto:' + THEME.email}>{THEME.email}</a>

                </Col>
            </Row>
        }


        return (

            <div>
                <Header paramHeader={this.state.paramHeader}/>

                <Result
                    status="success"
                    title={t('inscrTermine.confirmedTitle')}
                    subTitle={message}
                    extra={[
                        <Link
                            to={{
                                pathname: "/order/complete/" + this.state.idOrder,
                            }}
                        ><Button type="primary" key="console">
                            {t('dashboard.finalizeApplication')}
                        </Button></Link>,
                        <Link
                            to={{
                                pathname: "/",
                            }}
                        ><Button key="console" onClick={() => window.location.href = THEME.urls.site}>
                            {t('header.backToSite')}
                        </Button></Link>,
                    ]}
                />

                <Divider dashed/>
                <FooterApps/>
            </div>
        );
    }
}

export default InscrTermine;